var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubbleTextOvalStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Chat-Bubble-Text-Oval--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Chat Bubble Text Oval Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-bubble-text-oval--messages-message-bubble-text-chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#ffffff",
    d: "M19.16309927142857 34.651354714285716c10.656341442857144 0 16.650472157142858 -5.998640571428572 16.650472157142858 -16.66251612857143C35.81357142857143 7.324883442857144 29.81944071428572 1.3264285714285715 19.16309927142857 1.3264285714285715 8.506810885714286 1.3264285714285715 2.512635072857143 7.324883442857144 2.512635072857143 17.988838585714287c0 3.2555332285714287 0.5586572271428571 6.0762897 1.6380517414285716 8.424253971428572L1.4127074442857144 33.948082285714285c-0.39667377 1.0916507142857144 0.6416067642857143 2.158895142857143 1.7427865414285715 1.7917397142857143l7.839935657142858 -2.6151865714285716c2.2955438142857143 1.006494 5.029445742857144 1.526719285714286 8.16766962857143 1.526719285714286Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.16309927142857 34.651354714285716c10.656341442857144 0 16.650472157142858 -5.998640571428572 16.650472157142858 -16.66251612857143C35.81357142857143 7.324883442857144 29.81944071428572 1.3264285714285715 19.16309927142857 1.3264285714285715 8.506810885714286 1.3264285714285715 2.512635072857143 7.324883442857144 2.512635072857143 17.988838585714287c0 3.2555332285714287 0.5586572271428571 6.0762897 1.6380517414285716 8.424253971428572L1.4127074442857144 33.948082285714285c-0.39667377 1.0916507142857144 0.6416067642857143 2.158895142857143 1.7427865414285715 1.7917397142857143l7.839935657142858 -2.6151865714285716c2.2955438142857143 1.006494 5.029445742857144 1.526719285714286 8.16766962857143 1.526719285714286Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 496",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.766875 14.590714285714286h12.932678571428573",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 497",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.766875 22.549285714285716H22.549285714285716",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleTextOvalStreamlineFlex);
export default __webpack_public_path__ + "static/media/Chat-Bubble-Text-Oval--Streamline-Flex.cebf82e05b9b382e72da2cdd50df31b2.svg";
export { ForwardRef as ReactComponent };